/**
 * @author：
 * @update：
 * @description：
 **/
import CusPagination from '@/components/cusPagination.vue';
import axios from 'axios';
import { fileEcho, goodeReviewedList, downList, shopDetail, exportSpusFile } from '../../api/url';
import { detailUrl, requestUrl } from '../../config/config';
export default {
  components: {
    CusPagination
  },
  data() {
    return {
      callback: detailUrl + 'details?id=', //复制地址详情
      fileEcho: fileEcho, //openFile,//fileUpLoca
      goodsName: '', //商品名称
      goodsID: '', //商品id
      goodsShop: '', //所属店铺
      moneySectionVal: '', //价格区间
      moneySectionOption: [
        { label: '0-1000元', value: '0,1000' },
        { label: '1001-2000元', value: '1001,2000' },
        { label: '2001-3000元', value: '2001,3000' },
        { label: '3001-4000', value: '3001,4000' },
        { label: '4001-5000', value: '4001,5000' },
        { label: '5001以上', value: '5001' }
      ],
      transportVal: '', //运送方式
      transportOption: [
        { value: 'EXPRESS', label: '快递' },
        { value: 'ONLINE', label: '线上' },
        { value: 'DOWNLOAD', label: '下载' }
      ],
      goodsStateVal: '', //商品状态
      goodsStateOption: [
        { value: 'ON_SALE', label: '出售中' },
        { value: 'HALT_SALE', label: '下架' },
        { value: 'VIOLATION_HALT_SALE', label: '违规下架' },
        { value: 'FOR_SALE', label: '上架' },
        { value: 'RESERVE', label: '待上架' },
        { value: 'CREATE', label: '新建' }
      ],
      creationTime: [], //创建时间
      releaseTime: [], //发布时间
      tabsType: '0', //表格切换
      tabsTypeDisabled: false, //是否禁用商品状态下拉
      tableData: [], //表格数据
      page: 1,
      size: 10,
      count: 0,
      downWrapBol: false, //违规下架
      downId: '', //下架id
      cause: '', //违规原因
      exportVisible: false,
      allChecked: false,
      checkedBasic: [],
      basicGroup: [
        { title: '商品ID', name: 'unionId', type: 'VALUE' },
        { title: '运送方式', name: 'deliveryMode', type: 'VALUE' },
        { title: '商品状态', name: 'state', type: 'VALUE' },
        { title: '商品描述', name: 'description', type: 'VALUE' },
        { title: '定价模式', name: 'pricing', type: 'VALUE' },
        { title: '是否议价', name: 'bargain', type: 'VALUE' },
        { title: '库存控制', name: 'stockControl', type: 'VALUE' },
        { title: '是否提供发票', name: 'invoicePolicy', type: 'VALUE' },
        { title: '发票类型', name: 'serviceTypeEnum', type: 'VALUE' },
        { title: '是否定时开售', name: 'regularSale', type: 'VALUE' },
        { title: '定时开售时间', name: 'regularSaleTime', type: 'VALUE' },
        { title: '是否包邮', name: 'freePostage', type: 'VALUE' },
        { title: '运费', name: 'postage', type: 'VALUE' },
        // { title: '已售商品数量', name: 'soldOut', type: 'VALUE' },
        { title: '付款人次', name: 'payers', type: 'VALUE' },
        { title: '评论人次', name: 'comments', type: 'VALUE' },
        { title: '批次号', name: 'batchNumber', type: 'VALUE' },
        { title: '是否售罄', name: 'sellOut', type: 'VALUE' }
      ]
    };
  },
  // 自定义方法
  methods: {
    //列表数据
    dataList() {
      let data = {
        name: this.goodsName, //商品名称
        unionId: this.goodsID, //商品id
        storeName: this.goodsShop, //所属店铺
        price: this.moneySectionVal, //价格区间
        deliveryMode: this.transportVal, //运送方式
        state: this.goodsStateVal, //商品状态
        pageNumber: this.page,
        pageSize: this.size
      };
      if (this.creationTime != null && this.creationTime != '') {
        data.createdDate = this.creationTime.length == 0 ? '' : this.creationTime[0] + ' 00:00:00,' + this.creationTime[1] + ' 00:00:00';
      }
      if (this.releaseTime != null && this.releaseTime != '') {
        data.forSaleTime = this.releaseTime.length == 0 ? '' : this.releaseTime[0] + ' 00:00:00,' + this.releaseTime[1] + ' 00:00:00';
      }
      this.$ajax.get(goodeReviewedList, data).then(
        res => {
          console.log(res);
          this.count = res.data.total;
          this.tableData = res.data.rows;
        },
        err => {
          console.log(err);
          this.$message({
            showClose: true,
            message: err.data,
            type: 'error',
            center: true,
            duration: 3000
          });
        }
      );
    },
    //重置
    resetBtn() {
      this.goodsName = ''; //商品名称
      this.goodsID = ''; //商品id
      this.goodsShop = ''; //所属店铺
      this.moneySectionVal = ''; //价格区间
      this.transportVal = ''; //运送方式
      this.goodsStateVal = ''; //商品状态
      this.creationTime = []; //创建时间
      this.releaseTime = []; //发布时间
      this.page = 1;
    },
    //页面切换
    tabsTypeChange(num) {
      this.tabsType = num;
      this.page = 1;
      if (num == 0) {
        this.goodsStateVal = '';
        this.tabsTypeDisabled = false;
      } else if (num == 1) {
        this.goodsStateVal = 'ON_SALE';
        this.tabsTypeDisabled = true;
      } else if (num == 2) {
        this.goodsStateVal = 'RESERVE';
        this.tabsTypeDisabled = true;
      }
      this.dataList();
    },
    //表格多选
    selectChange(val) {
      console.log(val);
    },
    //编辑商品
    goodsDetail(id) {
      this.$router.push({ path: '/goodsDetail', query: { id: id, type: '' } });
    },
    //违规下架商品
    downGoods() {
      if (this.cause == '') {
        this.$message({
          showClose: true,
          message: '请填写违规下架的原因',
          type: 'error',
          center: true,
          duration: 3000
        });
        return false;
      }
      let data = {
        id: this.downId,
        cause: this.cause
      };
      this.$ajax.put(downList(this.downId), data).then(
        res => {
          console.log(res);
          this.downId = '';
          this.downWrapBol = false;
          this.cause = '';
          this.dataList();
          this.$message({
            showClose: true,
            message: '下架成功',
            type: 'success',
            center: true,
            duration: 3000
          });
        },
        err => {
          console.log(err);
          this.$message({
            showClose: true,
            message: err.data,
            type: 'error',
            center: true,
            duration: 3000
          });
        }
      );
    },
    //点击复制
    copySucc() {
      this.$message({
        showClose: true,
        message: '复制成功',
        type: 'success',
        center: true,
        duration: 1000
      });
    },
    copyErr() {
      this.$message({
        showClose: true,
        message: '复制失败',
        type: 'error',
        center: true,
        duration: 1000
      });
    },
    checkAll() {
      if (this.allChecked) {
        this.checkedBasic = this.basicGroup.map(item => item.name);
      } else {
        this.resetField();
      }
    },
    resetField() {
      this.checkedBasic = [];
      this.allChecked = false;
    },
    exportFile() {
      if(!this.checkedBasic.length) {
        this.$message.info("请至少选择一个字段！");
        return;
      }
      const fields = [];
      for (let index in this.checkedBasic) {
        for (let i in this.basicGroup) {
          if (this.basicGroup[i].name === this.checkedBasic[index]) {
            fields.push(this.basicGroup[i]);
            break;
          }
        }
      }
      const filter = {
        name: this.goodsName, //商品名称
        unionId: this.goodsID, //商品id
        storeName: this.goodsShop, //所属店铺
        price: this.moneySectionVal, //价格区间
        deliveryMode: this.transportVal, //运送方式
        state: this.goodsStateVal, //商品状态
        createdDate: '',
        forSaleTime: ''
      };
      if (this.creationTime !== null && this.creationTime !== '') {
        filter.createdDate = this.creationTime.length === 0 ? '' : this.creationTime[0] + ' 00:00:00,' + this.creationTime[1] + ' 00:00:00';
      }
      if (this.releaseTime !== null && this.releaseTime !== '') {
        filter.forSaleTime = this.releaseTime.length === 0 ? '' : this.releaseTime[0] + ' 00:00:00,' + this.releaseTime[1] + ' 00:00:00';
      }
      const data = {
        type: 'COLLECTION',
        title: '基本信息',
        fields
      };
      for (let key in filter) {
        if (filter[key] === '') {
          delete filter[key];
        }
      }
      this.$loading({ fullscreen: true, text: '导出中...这可能需要很长一段时间，请耐心等待。' });
      axios({
        url: requestUrl + exportSpusFile,
        method: 'post',
        data: data,
        params: filter,
        responseType: 'blob',
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('token')
        }
      }).then(res => {
        if (!res) return;
        let url = window.URL.createObjectURL(
          new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
        );
        const aEle = document.createElement('a'); // 创建a标签
        aEle.href = url;
        document.body.appendChild(aEle);
        aEle.click(); // 点击下载
        document.body.removeChild(aEle); // 下载完成移除元素
        window.URL.revokeObjectURL(url); // 释放掉blob对象
        this.$loading().close();
      }).catch(err => {
        this.$loading().close();
        this.$message.info("下载失败！");
      });
    }
  },
  // 数据观察监听
  watch: {
    $route(to, from) {
      //监听路由是否变化
      console.log(to, from);
      this.$router.go(0);
    },
    page(newData, oldData) {
      this.dataList();
    },
    size(newData, oldData) {
      this.page = 1;
      this.dataList();
    }
  },
  // 计算数据
  computed: {
    isIndeterminate() {
      if (this.basicGroup.length === this.checkedBasic.length) {
        this.allChecked = true;
      }
      if (this.checkedBasic.length === 0) {
        this.allChecked = false;
      }
      return this.checkedBasic.length > 0 && this.basicGroup.length !== this.checkedBasic.length;
    }
  },
  // 组件数据创建之前
  beforeCreate() {},
  // 组件数据创建完成
  created() {},
  // 组件挂载完成之前
  beforeMount() {
    console.log(this.$route.query.type);
    if (this.$route.query.shopId != undefined) {
      this.$ajax.get(shopDetail(this.$route.query.shopId), { id: this.$route.query.shopId }).then(
        res => {
          console.log(res);
          this.goodsShop = res.data.name;
          if (this.$route.query.type != '') {
            this.goodsStateVal = this.$route.query.type;
          }
          this.dataList();
        },
        err => {
          console.log(err);
        }
      );
    } else {
      this.dataList();
    }
  },
  // 组件挂载完成
  mounted() {},
  // 组件即将销毁
  beforeDestroy() {},
  // 组件销毁
  destroyed() {},
  // 组件激活
  activated() {},
  // 组件冻结
  deactivated() {}
};
